import React from 'react';
import * as PropTypes from 'prop-types';
import Button from '../Button';

const Finish = ({ onConfirm }) => {
  return (
    <article className="ap-receive is-finish">
      <section className="ap-receive-calendar-icon" />
      <section className="ap-receive-main">
        <h3>您已经完成任务啦</h3>
        <p>
          奖品已经分别发到您的账号和手机号
          <br />
          请及时使用
        </p>
        <Button
          className="ap-receive-button"
          text="知道了"
          theme="white"
          onClick={onConfirm}
        />
      </section>
    </article>
  );
};

Finish.propTypes = {
  onConfirm: PropTypes.func.isRequired
};

export default Finish;
